<template>
<div class="">
    <router-link
      to="/order"
    >
    <span class="amount">
     {{productCart.length}}
    </span>
    <fab
    :position='position'
    :bg-color="bgColor"
    :main-icon="mainIcon"
    ></fab>
    </router-link>
</div>
</template>

<script>
import fab from 'vue-fab';
import { mapState } from 'vuex';

export default {
  name: 'OrderFloatIcon',
  components: {
    fab
  },
  computed: mapState({
    productCart: state => state.productCart,
  }),
  data() {
    return {
      mainIcon: 'shopping_basket',
      bgColor: '#FFB900',
      position: 'bottom-right',
      fabActions: [
        {
          name: 'cache',
          icon: 'cached'
        },
        {
          name: 'alertMe',
          icon: 'add_alert'
        }
      ]
    };
  },
  methods: {
    cache() {
      console.log('Cache Cleared');
    },
    alert() {
      alert('Clicked on alert icon');
    }
  }
};
</script>

<style lang="scss" scoped>
body{
    z-index: 998;
}
.amount{
    z-index: 9999;
    position: fixed;
    right: 5vw;
    // bottom: 10vh;
    bottom:80px;
    background: red;
    color:white;
    width: 25px;
    height: 25px;
    border-radius: 20px;
    text-align: center;
}
</style>
